export let NoteMIDI = {

    "C0": 12,
    "C1": 24,
    "C2": 36,
    "C3": 48,
    "C4": 60,
    "C5": 72,
    "C6": 84,
    "C7": 96,
    "C8": 108,
    "C9": 120,
    "C#0": 13,
    "C#1": 25,
    "C#2": 37,
    "C#3": 49,
    "C#4": 61,
    "C#5": 73,
    "C#6": 85,
    "C#7": 97,
    "C#8": 109,
    "C#9": 121,
    "D0": 14,
    "D1": 26,
    "D2": 38,
    "D3": 50,
    "D4": 62,
    "D5": 74,
    "D6": 86,
    "D7": 98,
    "D8": 110,
    "D9": 122,
    "D#0": 15,
    "D#1": 27,
    "D#2": 39,
    "D#3": 51,
    "D#4": 63,
    "D#5": 75,
    "D#6": 87,
    "D#7": 99,
    "D#8": 111,
    "D#9": 123,
    "E0": 16,
    "E1": 28,
    "E2": 40,
    "E3": 52,
    "E4": 64,
    "E5": 76,
    "E6": 88,
    "E7": 100,
    "E8": 112,
    "E9": 124,
    "F0": 17,
    "F1": 29,
    "F2": 41,
    "F3": 53,
    "F4": 65,
    "F5": 77,
    "F6": 89,
    "F7": 101,
    "F8": 113,
    "F9": 125,
    "F#0": 18,
    "F#1": 30,
    "F#2": 42,
    "F#3": 54,
    "F#4": 66,
    "F#5": 78,
    "F#6": 90,
    "F#7": 102,
    "F#8": 114,
    "F#9": 126,
    "G0": 19,
    "G1": 31,
    "G2": 43,
    "G3": 55,
    "G4": 67,
    "G5": 79,
    "G6": 91,
    "G7": 103,
    "G8": 115,
    "G9": 127,
    "G#0": 20,
    "G#1": 32,
    "G#2": 44,
    "G#3": 56,
    "G#4": 68,
    "G#5": 80,
    "G#6": 92,
    "G#7": 104,
    "G#8": 116,
    "A0": 21,
    "A1": 33,
    "A2": 45,
    "A3": 57,
    "A4": 69,
    "A5": 81,
    "A6": 93,
    "A7": 105,
    "A8": 117,
    "A#0": 22,
    "A#1": 34,
    "A#2": 46,
    "A#3": 58,
    "A#4": 70,
    "A#5": 82,
    "A#6": 94,
    "A#7": 106,
    "A#8": 118,
    "B0": 23,
    "B1": 35,
    "B2": 47,
    "B3": 59,
    "B4": 71,
    "B5": 83,
    "B6": 95,
    "B7": 107,
    "B8": 119,
    "Db0": 13,
    "Db1": 25,
    "Db2": 37,
    "Db3": 49,
    "Db4": 61,
    "Db5": 73,
    "Db6": 85,
    "Db7": 97,
    "Db8": 109,
    "Db9": 121,
    "Eb0": 15,
    "Eb1": 27,
    "Eb2": 39,
    "Eb3": 51,
    "Eb4": 63,
    "Eb5": 75,
    "Eb6": 87,
    "Eb7": 99,
    "Eb8": 111,
    "Eb9": 123,
    "Gb0": 18,
    "Gb1": 30,
    "Gb2": 42,
    "Gb3": 54,
    "Gb4": 66,
    "Gb5": 78,
    "Gb6": 90,
    "Gb7": 102,
    "Gb8": 114,
    "Gb9": 126,
    "Ab0": 20,
    "Ab1": 32,
    "Ab2": 44,
    "Ab3": 56,
    "Ab4": 68,
    "Ab5": 80,
    "Ab6": 92,
    "Ab7": 104,
    "Ab8": 116,
    "Bb0": 22,
    "Bb1": 34,
    "Bb2": 46,
    "Bb3": 58,
    "Bb4": 70,
    "Bb5": 82,
    "Bb6": 94,
    "Bb7": 106,
    "Bb8": 118,

    'KICK': 10,
    'CLOSED_HIT_HAT': 42,
    'SNARE': 38
}

export let MIDInote = {
    12: 'C0',
    24: 'C1',
    36: 'C2',
    48: 'C3',
    60: 'C4',
    72: 'C5',
    84: 'C6',
    96: 'C7',
    108: 'C8',
    120: 'C9',
    13: 'Db0',
    25: 'Db1',
    37: 'Db2',
    49: 'Db3',
    61: 'Db4',
    73: 'Db5',
    85: 'Db6',
    97: 'Db7',
    109: 'Db8',
    121: 'Db9',
    14: 'D0',
    26: 'D1',
    38: 'D2',
    50: 'D3',
    62: 'D4',
    74: 'D5',
    86: 'D6',
    98: 'D7',
    110: 'D8',
    122: 'D9',
    15: 'Eb0',
    27: 'Eb1',
    39: 'Eb2',
    51: 'Eb3',
    63: 'Eb4',
    75: 'Eb5',
    87: 'Eb6',
    99: 'Eb7',
    111: 'Eb8',
    123: 'Eb9',
    16: 'E0',
    28: 'E1',
    40: 'E2',
    52: 'E3',
    64: 'E4',
    76: 'E5',
    88: 'E6',
    100: 'E7',
    112: 'E8',
    124: 'E9',
    17: 'F0',
    29: 'F1',
    41: 'F2',
    53: 'F3',
    65: 'F4',
    77: 'F5',
    89: 'F6',
    101: 'F7',
    113: 'F8',
    125: 'F9',
    18: 'Gb0',
    30: 'Gb1',
    42: 'Gb2',
    54: 'Gb3',
    66: 'Gb4',
    78: 'Gb5',
    90: 'Gb6',
    102: 'Gb7',
    114: 'Gb8',
    126: 'Gb9',
    19: 'G0',
    31: 'G1',
    43: 'G2',
    55: 'G3',
    67: 'G4',
    79: 'G5',
    91: 'G6',
    103: 'G7',
    115: 'G8',
    127: 'G9',
    20: 'Ab0',
    32: 'Ab1',
    44: 'Ab2',
    56: 'Ab3',
    68: 'Ab4',
    80: 'Ab5',
    92: 'Ab6',
    104: 'Ab7',
    116: 'Ab8',
    21: 'A0',
    33: 'A1',
    45: 'A2',
    57: 'A3',
    69: 'A4',
    81: 'A5',
    93: 'A6',
    105: 'A7',
    117: 'A8',
    22: 'Bb0',
    34: 'Bb1',
    46: 'Bb2',
    58: 'Bb3',
    70: 'Bb4',
    82: 'Bb5',
    94: 'Bb6',
    106: 'Bb7',
    118: 'Bb8',
    23: 'B0',
    35: 'B1',
    47: 'B2',
    59: 'B3',
    71: 'B4',
    83: 'B5',
    95: 'B6',
    107: 'B7',
    119: 'B8'
}

export let MIDIfreq = {

    11: 15.434,
    12: 16.352,
    13: 17.324,
    14: 18.354,
    15: 19.445,
    16: 20.602,
    17: 21.827,
    18: 23.125,
    19: 24.5,
    20: 25.957,
    21: 27.5,
    22: 29.135,
    23: 30.868,
    24: 32.703,
    25: 34.648,
    26: 36.708,
    27: 38.891,
    28: 41.203,
    29: 43.654,
    30: 46.249,
    31: 48.999,
    32: 51.913,
    33: 55,
    34: 58.27,
    35: 61.735,
    36: 65.406,
    37: 69.296,
    38: 73.416,
    39: 77.782,
    40: 82.407,
    41: 87.307,
    42: 92.499,
    43: 97.999,
    44: 103.83,
    45: 110,
    46: 116.54,
    47: 123.47,
    48: 130.81,
    49: 138.59,
    50: 146.83,
    51: 155.56,
    52: 164.81,
    53: 174.61,
    54: 185,
    55: 196,
    56: 207.65,
    57: 220,
    58: 233.08,
    59: 246.94,
    60: 261.63,
    61: 277.18,
    62: 293.66,
    63: 311.13,
    64: 329.63,
    65: 349.23,
    66: 369.99,
    67: 392,
    68: 415.3,
    69: 440,
    70: 466.16,
    71: 493.88,
    72: 523.25,
    73: 554.37,
    74: 587.33,
    75: 622.25,
    76: 659.26,
    77: 698.46,
    78: 739.99,
    79: 783.99,
    80: 830.61,
    81: 880,
    82: 932.33,
    83: 987.77,
    84: 1046.5,
    85: 1108.7,
    86: 1174.7,
    87: 1244.5,
    88: 1318.5,
    89: 1396.9,
    90: 1480,
    91: 1568,
    92: 1661.2,
    93: 1760,
    94: 1864.7,
    95: 1975.5,
    96: 2093,
    97: 2217.5,
    98: 2349.3,
    99: 2489,
    100: 2637,
    101: 2793.8,
    102: 2960,
    103: 3136,
    104: 3322.4,
    105: 3520,
    106: 3729.3,
    107: 3951.1,
    108: 4186,
    109: 4434.9,
    110: 4698.6,
    111: 4978,
    112: 5274,
    113: 5587.7,
    114: 5919.9,
    115: 6271.9,
    116: 6644.9,
    117: 7040,
    118: 7458.6,
    119: 7902.1,
    120: 8372,
    121: 8869.8,
    122: 9397.3,
    123: 9956.1,
    124: 10548,
    125: 11175,
    126: 11840,
    127: 12544,
    128: 13290,
    129: 14080,
    130: 14917,
    131: 15804,
    132: 16744
}

export let DegreeStep = {
    "1": 0,
    "b2": 1,
    "2": 2,
    "#2": 3,
    "b3": 3,
    "3": 4,
    "b4": 4,
    "4": 5,
    "#4": 6,
    "b5": 6,
    "5": 7,
    "#5": 8,
    "b6": 8,
    "6": 9,
    "bb7": 9,
    "b7": 10,
    "7": 11,
    "b9": 1,
    "9": 2,
    "#9": 3,
    "b11": 3,
    "11": 5,
    "#11": 6,
    "b13": 8,
    "13": 9,
    "#13": 10
}

export let stepToTones = {
    0: '1', 1: 'b2', 2: '2', 3: 'b3', 4: '3', 5: '4', 6: '#4', 7: '5', 8: 'b6', 9: '6', 10: 'b7', 11: '7'
}


export let roots = [{'id': 0, 'name': 'C', 'step': 0}, {'id': 1, 'name': 'D', 'step': 2}, {'id': 2, 'name': 'E', 'step': 4}, {'id': 3, 'name': 'F', 'step': 5}, {'id': 4, 'name': 'G', 'step': 7},
    {'id': 5, 'name': 'A', 'step': 9}, {'id': 6, 'name': 'B', 'step': 11}, {'id': 7, 'name': 'C#', 'step': 1}, {'id': 8, 'name': 'D#', 'step': 3}, {'id': 9, 'name': 'F#', 'step': 6},
    {'id': 10, 'name': 'G#', 'step': 8}, {'id': 11, 'name': 'A#', 'step': 10},

    {'id': 12, 'name': 'Db', 'step': 1}, {'id': 13, 'name': 'Eb', 'step': 3}, {'id': 14, 'name': 'Gb', 'step': 6}, {'id': 15, 'name': 'Ab', 'step': 8}, {'id': 16, 'name': 'Bb', 'step': 10},]


export let stepColorMapping = [

    'color_degree_0', 'color_degree_1', 'color_degree_2', 'color_degree_3', 'color_degree_4', 'color_degree_5', 'color_degree_6', 'color_degree_7', 'color_degree_8', 'color_degree_9',
    'color_degree_10', 'color_degree_11']

export function computeNoteClass(note_step, current_root_step) {
    //trasla colori in base alla root impostata root impostato
    let id = (note_step % 12) - current_root_step;
    if (id < 0) {
        id = id + 12;
    }

    return stepColorMapping[id];
}

export function getToneFromStep(step) {
    let values = ['1', 'b2', '2', 'b3', '3', '4', '#4', '5', 'b6', '6', 'b7', '7']

    return values[step];
}

export function getNoteFromStep(step) {
    let values = ['C', 'C#', 'D', 'Eb', 'E', 'F', 'F#', 'G', 'G#', 'A', 'Bb', 'B']

    return values[step];
}


export let KEYS = {
    'C': {'notes': ['C', 'D', 'E', 'F', 'G', 'A', 'B', 'C'], 'step': 0},
    'G': {'notes': ['G', 'A', 'B', 'C', 'D', 'E', 'F#', 'G'], 'step': 7},
    'D': {'notes': ['D', 'E', 'F#', 'G', 'A', 'B', 'C#', 'D'], 'step': 2},
    'A': {'notes': ['A', 'B', 'C#', 'D', 'E', 'F#', 'G#', 'A'], 'step': 9},
    'E': {'notes': ['E', 'F#', 'G#', 'A', 'B', 'C#', 'D#', 'E'], 'step': 4},
    'B': {'notes': ['B', 'C#', 'D#', 'E', 'F#', 'G#', 'A#', 'B'], 'step': 11},
    'F#': {'notes': ['F#', 'G#', 'A#', 'B', 'C#', 'D#', 'E#', 'F#'], 'step': 6},
    'Gb': {'notes': ['Gb', 'Ab', 'Bb', 'Cb', 'Db', 'Eb', 'F', 'Gb'], 'step': 6},
    'C#': {'notes': ['C#', 'D#', 'E#', 'F#', 'G#', 'A#', 'B#', 'C#'], 'step': 1},
    'Db': {'notes': ['Db', 'Eb', 'F', 'Gb', 'Ab', 'Bb', 'C', 'Db'], 'step': 1},
    'G#': {'notes': ['G#', 'A#', 'B#', 'C#', 'D#', 'E#', 'F##', 'G#'], 'step': 8},
    'Ab': {'notes': ['Ab', 'Bb', 'C', 'Db', 'Eb', 'F', 'G', 'Ab'], 'step': 8},
    'D#': {'notes': ['D#', 'E#', 'F##', 'G#', 'A#', 'B#', 'C##', 'D#'], 'step': 3},
    'Eb': {'notes': ['Eb', 'F', 'G', 'Ab', 'Bb', 'C', 'D', 'Eb'], 'step': 3},
    'A#': {'notes': ['A#', 'B#', 'C##', 'D#', 'E#', 'F##', 'G##', 'A#'], 'step': 10},
    'Bb': {'notes': ['Bb', 'C', 'D', 'Eb', 'F', 'G', 'A', 'Bb'], 'step': 10},
    'F': {'notes': ['F', 'G', 'A', 'Bb', 'C', 'D', 'E', 'F'], 'step': 5}
}

export let CHORD_TYPES = {
    '5': {'steps': [0, 7], 'tones': ['1', '5'], 'slug': '5'},
    'maj': {'steps': [0, 4, 7], 'tones': ['1', '3', '5'], 'slug': 'maj'},
    'maj7': {'steps': [0, 4, 7, 11], 'tones': ['1', '3', '5', '7'], 'slug': 'maj7'},
    'maj9': {'steps': [0, 4, 7, 11, 14], 'tones': ['1', '3', '5', '7', '9'], 'slug': 'maj9'},
    'maj11': {'steps': [0, 4, 7, 11, 14, 17], 'tones': ['1', '3', '5', '7', '9', '11'], 'slug': 'maj11'},
    'maj13': {'steps': [0, 4, 7, 11, 14, 17, 21], 'tones': ['1', '3', '5', '7', '9', '11', '13'], 'slug': 'maj13'},
    '6': {'steps': [0, 4, 7, 9], 'tones': ['1', '3', '5', '6'], 'slug': '6'},
    'sus2': {'steps': [0, 2, 7], 'tones': ['1', '2', '5'], 'slug': 'sus2'},
    'sus4': {'steps': [0, 5, 7], 'tones': ['1', '4', '5'], 'slug': 'sus4'},
    'add9': {'steps': [0, 4, 7, 14], 'tones': ['1', '3', '5', '9'], 'slug': 'add9'},
    '6/9': {'steps': [0, 4, 7, 9, 14], 'tones': ['1', '3', '5', '6', '9'], 'slug': '6-9'},
    'maj7b5': {'steps': [0, 4, 6, 11], 'tones': ['1', '3', 'b5', '7'], 'slug': 'maj7b5'},
    'maj7#5': {'steps': [0, 4, 8, 11], 'tones': ['1', '3', '#5', '7'], 'slug': 'maj7-sharp-5'},
    'maj7#11': {'steps': [0, 4, 7, 11, 18], 'tones': ['1', '3', '5', '7', '#11'], 'slug': 'maj7-sharp11'},
    'm': {'steps': [0, 3, 7], 'tones': ['1', 'b3', '5'], 'slug': 'm'},
    'm7': {'steps': [0, 3, 7, 10], 'tones': ['1', 'b3', '5', 'b7'], 'slug': 'm7'},
    'm9': {'steps': [0, 3, 7, 10, 14], 'tones': ['1', 'b3', '5', 'b7', '9'], 'slug': 'm9'},
    'm11': {'steps': [0, 3, 7, 10, 14, 17], 'tones': ['1', 'b3', '5', 'b7', '9', '11'], 'slug': 'm11'},
    'm13': {'steps': [0, 3, 7, 10, 14, 17, 21], 'tones': ['1', 'b3', '5', 'b7', '9', '11', '13'], 'slug': 'm13'},
    'm6': {'steps': [0, 3, 7, 9], 'tones': ['1', 'b3', '5', '6'], 'slug': 'm6'},
    'm(maj7)': {'steps': [0, 3, 7, 11], 'tones': ['1', 'b3', '5', '7'], 'slug': 'm-maj7'},
    'm(maj9)': {'steps': [0, 3, 7, 11, 14], 'tones': ['1', 'b3', '5', '7', '9'], 'slug': 'm-maj9'},
    'm7b5': {'steps': [0, 3, 6, 10], 'tones': ['1', 'b3', 'b5', 'b7'], 'slug': 'm7b5'},
    'm7#5': {'steps': [0, 3, 8, 10], 'tones': ['1', 'b3', '#5', 'b7'], 'slug': 'm7-sharp-5'},
    '7': {'steps': [0, 4, 7, 10], 'tones': ['1', '3', '5', 'b7'], 'slug': '7'},
    '9': {'steps': [0, 4, 7, 10, 14], 'tones': ['1', '3', '5', 'b7', '9'], 'slug': '9'},
    '11': {'steps': [0, 4, 7, 10, 14, 17], 'tones': ['1', '3', '5', 'b7', '9', '11'], 'slug': '11'},
    '13': {'steps': [0, 4, 7, 10, 14, 17, 21], 'tones': ['1', '3', '5', 'b7', '9', '11', '13'], 'slug': '13'},
    '7sus4': {'steps': [0, 5, 7, 10], 'tones': ['1', '4', '5', 'b7'], 'slug': '7sus4'},
    '7b5': {'steps': [0, 4, 6, 10], 'tones': ['1', '3', 'b5', 'b7'], 'slug': '7b5'},
    '7#5': {'steps': [0, 4, 8, 10], 'tones': ['1', '3', '#5', 'b7'], 'slug': '7-sharp-5'},
    '7b9': {'steps': [0, 4, 7, 10, 13], 'tones': ['1', '3', '5', 'b7', 'b9'], 'slug': '7-b9'},
    '7#9': {'steps': [0, 4, 7, 10, 15], 'tones': ['1', '3', '5', 'b7', '#9'], 'slug': '7-sharp-9'},
    '7b5(b9)': {'steps': [0, 4, 6, 10, 13], 'tones': ['1', '3', 'b5', 'b7', 'b9'], 'slug': '7b5-b9'},
    '7#5(b9)': {'steps': [0, 4, 8, 10, 13], 'tones': ['1', '3', '#5', 'b7', 'b9'], 'slug': '7-sharp-5-b9'},
    '9b5': {'steps': [0, 4, 6, 10, 14], 'tones': ['1', '3', 'b5', 'b7', '9'], 'slug': '9b5'},
    '9#5': {'steps': [0, 4, 8, 10, 14], 'tones': ['1', '3', '#5', 'b7', '9'], 'slug': '9-sharp-5'},
    '13(#11)': {'steps': [0, 4, 7, 10, 14, 18, 21], 'tones': ['1', '3', '5', 'b7', '9', '#11', '13'], 'slug': '13-sharp-11'},
    '13(b9)': {'steps': [0, 4, 7, 10, 13, 17, 21], 'tones': ['1', '3', '5', 'b7', 'b9', '11', '13'], 'slug': '13-b9'},
    '11(b9)': {'steps': [0, 4, 7, 10, 13, 17], 'tones': ['1', '3', '5', 'b7', 'b9', '11'], 'slug': '11-b9'},
    'aug': {'steps': [0, 4, 8], 'tones': ['1', '3', '#5'], 'slug': 'aug'},
    'aug7': {'steps': [0, 4, 8, 10], 'tones': ['1', '3', '#5', 'b7'], 'slug': 'aug7'},
    'dim': {'steps': [0, 3, 6], 'tones': ['1', 'b3', 'b5'], 'slug': 'dim'},
    'dim7': {'steps': [0, 3, 6, 9], 'tones': ['1', 'b3', 'b5', 'bb7'], 'slug': 'dim7'}
}

export let SCALE_TYPES = {

    'Major': {'tones': ['1', '2', '3', '4', '5', '6', '7']},
    'Minor': {'tones': ['1', '2', 'b3', '4', '5', 'b6', 'b7']},
    'Major Pentatonic': {'tones': ['1', '2', '3', '5', '6']},
    'Minor Pentatonic': {'tones': ['1', 'b3', '4', '5', 'b7']},
    'Major Blues': {'tones': ['1', '2', 'b3', '3', '5', '6']},
    'Minor Blues': {'tones': ['1', 'b3', '4', 'b5', '5', 'b7']},
    'Harmonic Minor': {'tones': ['1', '2', 'b3', '4', '5', 'b6', '7']},
    'Melodic Minor': {'tones': ['1', '2', 'b3', '4', '5', '6', '7']},
    'Dorian': {'tones': ['1', '2', 'b3', '4', '5', '6', 'b7']},
    'Phrygian': {'tones': ['1', 'b2', 'b3', '4', '5', 'b6', 'b7']},
    'Lydian': {'tones': ['1', '2', '3', '#4', '5', '6', '7']},
    'Mixolydian': {'tones': ['1', '2', '3', '4', '5', '6', 'b7']},
    'Locrian': {'tones': ['1', 'b2', 'b3', '4', 'b5', 'b6', 'b7']},
    'Half-Whole': {'tones': ['1', 'b2', '#2', '3', '#4', '5', '6', 'b7']},
    'Whole-Half': {'tones': ['1', '2', 'b3', '4', 'b5', 'b6', '6', '7']},
    'Whole-Tone': {'tones': ['1', '2', '3', '#4', '#5', 'b7']},


    'Ionian #5': {'tones': ['1', '2', '3', '4', '#5', '6', '7']},
    'Aeolian b5': {'tones': ['1', '2', 'b3', '4', 'b5', 'b6', 'b7']},
    'Dorian #4': {'tones': ['1', '2', 'b3', '#4', '5', '6', 'b7']},
    'Dorian b2': {'tones': ['1', 'b2', 'b3', '4', '5', '6', 'b7']},
    'Lydian #2': {'tones': ['1', '#2', '3', '#4', '5', '6', '7']},
    'Lydian Augmented': {'tones': ['1', '2', '3', '#4', '#5', '6', '7']},
    'Lydian Dominant': {'tones': ['1', '2', '3', '#4', '5', '6', 'b7']},
    'Mixolydian b6': {'tones': ['1', '2', '3', '4', '5', 'b6', 'b7']},
    'Locrian #6': {'tones': ['1', 'b2', 'b3', '4', 'b5', '6', 'b7']},
    'Phrygian Dominant': {'tones': ['1', 'b2', '3', '4', '5', 'b6', 'b7']},
    'Super Locrian': {'tones': ['1', 'b2', 'b3', 'b4', 'b5', 'b6', 'b7']},
    'Super Locrian bb7': {'tones': ['1', 'b2', 'b3', 'b4', 'b5', 'b6', 'bb7']},


    'Arabic': {'tones': ['1', '2', 'b3', '4', '#4', '#5', '6', '7']},
    'Bizantine': {'tones': ['1', 'b2', '3', '4', '5', 'b6', '7']},
    'Gipsy Hungarian': {'tones': ['1', '2', 'b3', '#4', '5', 'b6', '7']},
    'Indian': {'tones': ['1', 'b2', '4', '5', 'b6']},
    'Japanese': {'tones': ['1', '2', '4', '5', 'b6']},
    'Jewish': {'tones': ['1', 'b2', '3', '4', '5', 'b6', 'b7']},
    'Neapolitan': {'tones': ['1', 'b2', 'b3', '4', '5', '6', '7']},
    'Persian': {'tones': ['1', 'b2', '3', '4', 'b5', 'b6', '7']},

}

/*
esempio:
root name: G
tones = [1,b3,5
 */
export function computeStepsAndNames(root_name, tones) {


    let buffer = [];
    let key = KEYS[root_name];


    for (let i = 0; i < tones.length; i++) {
        // calcola step della struttura e li trasla in tonalità
        let base_step = DegreeStep[tones[i]];
        let step = base_step + key.step;
        if (step > 11) {
            step = step - 12;
        }

        //calcola nomi note
        let tone = tones[i];
        // posizione 1-7 nella scale
        let degree = parseInt(tone.replace(/#/g, '').replace(/b/g, ''), 10);
        // tiene trccia di # e b
        let accidentals = tone.replace(degree, '');

        if (degree === 9) {
            degree = 2;
        }

        if (degree === 11) {
            degree = 4
        }

        if (degree === 13) {
            degree = 6
        }

        // nome nota senza alterazioni
        let natural_note = key.notes[degree - 1];
        //aggiunge alterazioni
        let note = natural_note + accidentals;
        //elimina casi strani
        note = note.replace('#b', '').replace('b#', '')

        buffer.push({'note': note, 'step': step, 'tone': tones[i]})
    }


    return buffer;
}

